import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { enum_api_uri } from "../utils/enum";

interface DeleteRequest {
    list_no: number[];
}

interface DeleteResponse {
    statusCode: number;
    message: string;
    data: null;
}

export const useDeleteConsoleQrSystem = (onSuccessCallback?: () => void): UseMutationResult<DeleteResponse, Error, DeleteRequest> => {
    const queryClient = useQueryClient();

    return useMutation<DeleteResponse, Error, DeleteRequest>({
        mutationFn: async (body: DeleteRequest) => {
            const url = enum_api_uri.delete_console_qr_system_request;
            const res = await axiosInstance.delete(url, { data: body });
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleQrSystem"] });
            onSuccessCallback?.();
        },
    });
};
